/* eslint-disable */
export default {
  meetingTitle: 'Riunione {extensionName}',
} as const;

// @key: @#@"meetingTitle"@#@ @source: @#@"{extensionName}'s Meeting"@#@
